import { onAuthStateChanged } from 'firebase/auth'
import { HttpError } from 'ra-core'
import { fetchUtils } from 'react-admin'

import env from '../config/env'

export default (firebaseClient) => {
  const onAuthLoad = () =>
    new Promise((resolve) => {
      onAuthStateChanged(firebaseClient.auth, resolve)
    })

  return async (url, { rawResponse, ...options } = {}) => {
    await onAuthLoad()
    const currentUser = firebaseClient.auth.currentUser
    let token
    if (currentUser) {
      token = await currentUser.getIdToken()
      if (token) {
        options.user = {
          authenticated: true,
          token: `Bearer ${token}`,
        }
      }
    }

    options.headers = new Headers({
      ...Object.fromEntries(options?.headers ?? []),
      Accept: env.API_VERSION,
      'x-app-code': env.ENV_NAME,
    })

    if (token) {
      options.headers.set('Authorization', `Bearer ${token}`)
    }

    if (rawResponse) {
      const response = await fetch(url, options)

      if (!response.ok) {
        let body
        try {
          body = await response.json()
        } catch {
          body = undefined
        }

        throw new HttpError(response.statusText || 'Request failed', response.status, body)
      }

      return response
    }

    return fetchUtils.fetchJson(url, options)
  }
}
